import React from "react";
import StatusPill from "./StatusPill";

function formatRequestDate(value) {
  if (!value) return "—";
  return new Intl.DateTimeFormat("en", {
    month: "short",
    day: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit"
  }).format(new Date(value));
}

function getReviewCommentsLabel(status) {
  const normalized = String(status || "").toLowerCase();
  if (normalized === "approved") return "Approved comments:";
  if (normalized === "rejected") return "Rejected comments:";
  return "Comments:";
}

export default function RequestCard({ item, actions = null, form = null }) {
  const requestComments = item?.request_comments?.trim() || "";
  const comments = item?.comments?.trim() || "";
  const cancellationComments = item?.cancellation_comments?.trim() || "";
  const reviewCommentsLabel = getReviewCommentsLabel(item?.status);

  return (
    <div className="request-item">
      <div className="request-item-summary">
        <div className="request-item-main">
          <div className="request-token-count">
            <strong>
              {Number(item?.token_amount || 0).toLocaleString()} tokens
            </strong>
            <span className="request-lessor-name">
              Lessor: {item?.lessor_name || "—"}
            </span>
          </div>
          <div className="request-details">
            <div className="request-details-primary">
              <span>
                ${Number(item?.amount_usd || 0).toLocaleString()} ·{" "}
                {formatRequestDate(item?.created_at)}
              </span>
              <span>
                Requested by: {item?.user_name || item?.user_id || "—"}
              </span>
            </div>
            <div className="request-details-secondary">
              {item?.billing_period ? (
                <span>Billing period: {item.billing_period}</span>
              ) : null}
              {item?.estimated_queries != null && item?.estimated_queries !== "" ? (
                <span>
                  Estimated queries: ~
                  {Number(item.estimated_queries).toLocaleString()}
                </span>
              ) : null}
            </div>
          </div>
          {requestComments || comments || cancellationComments ? (
            <div className="request-comments-block">
              {requestComments ? (
                <span className="request-comments">
                  Request comments: {requestComments}
                </span>
              ) : null}
              {comments ? (
                <span className="request-comments">
                  {reviewCommentsLabel} {comments}
                </span>
              ) : null}
              {cancellationComments ? (
                <span className="request-comments">
                  Cancellation comments: {cancellationComments}
                </span>
              ) : null}
            </div>
          ) : null}
        </div>
        <div className="request-status-actions">
          <StatusPill status={item?.status} />
          {actions}
        </div>
      </div>
      {form}
    </div>
  );
}
